import store from "@builder/store/store";
import { buildSizes } from "@common/build/constants";
import { BaseLayer, BaseLayerTypes } from "@common/build/types";

export type LayerDetails = {
    type: BaseLayerTypes;
    index: number;
    layer: BaseLayer;
};



export const getLayerById = (layerId: string): LayerDetails | null => {
    for (const layerType of Object.values(BaseLayerTypes)) {
        const layers = store.getState().builder.build[layerType];
        for (const layer of layers) {
            if (layer.id === layerId) {
                return {
                    type: layerType as BaseLayerTypes,
                    index: layers.indexOf(layer),
                    layer: layer
                };
            }
        }
    }
    return null;
};

export const searchLayerByName = (name: string): LayerDetails[] => {
    name = name?.trim()?.toLowerCase();
    if (!name) {
        return [];
    }
    const matches: LayerDetails[] = [];
    for (const layerType of Object.values(BaseLayerTypes)) {
        const layers = store.getState().builder.build[layerType];
        for (const layer of layers) {
            if (layer.name.trim().toLowerCase() === name) {
                matches.push({
                    type: layerType as BaseLayerTypes,
                    index: layers.indexOf(layer),
                    layer: layer
                });
            }
        }
    }
    return matches;
};

export const getSelectedNodeId = () => {
    const builderState = store.getState().builder;
    return builderState.selectedNode;
};

export const getBuildSize = () => {
    const buildSize = store.getState().builder.build.size;
    const deviceType = buildSizes[buildSize.key]?.type?.toLowerCase() || "Custom size: " + buildSize.frameSize?.x + "x" + buildSize.frameSize?.y;
    return deviceType;
};
